/**
 * Seamless.AI — B2B contact / prospecting overlay
 *
 * Declares two WAR groups matched to every http(s) origin with no use_dynamic_url:
 * flyout.html and a build-hashed worker (js/duWorker.<hash>.js). The worker name
 * rotates per release, but flyout.html — the overlay panel the content script injects —
 * keeps a stable name at a fixed URL, so a single fetch that succeeds is conclusive.
 *
 * Manifest verified against version 13.55.30.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'dbepenphjfofmnjmlacfcdehikakmaap';

export const seamlessAi: ExtensionDefinition = {
  id: ID,
  name: 'Seamless.AI',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  notes:
    'Exposes flyout.html and a build-hashed worker to every origin with no dynamic URL. ' +
    'Detection uses the stable flyout.html and is conclusive.',
  signals: [
    {
      id: 'war-flyout-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch flyout.html — the overlay panel exposed to every origin at a fixed URL. ' +
        'The only stable WAR name; the worker bundle is build-hashed.',
      weight: 1,
      run: () => probeFetch(ID, 'flyout.html'),
    },
  ],
};
